import { forwardRef } from "react";
import PropTypes from "prop-types";
import { Box, Tooltip } from "@mui/material";

/** Dark pill of icon buttons shown over an image on hover: `actions` = [{ label, Icon, onClick }]. */
export const ImageActionsToolbar = forwardRef(function ImageActionsToolbar({ actions, tooltipProps, className, sx }, ref) {
  return (
    <Box
      ref={ref}
      className={className}
      sx={{ display: "flex", gap: "2px", p: "3px", borderRadius: "8px", backgroundColor: "rgba(17, 24, 39, 0.85)", zIndex: 3, ...sx }}
    >
      {actions.map(({ label, Icon, onClick }) => (
        <Tooltip key={label} {...tooltipProps} title={label} arrow>
          <Box
            component="button"
            type="button"
            aria-label={label}
            onClick={(event) => {
              event.stopPropagation();
              onClick();
            }}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 28,
              height: 28,
              border: "none",
              borderRadius: "6px",
              background: "none",
              color: "#fff",
              cursor: "pointer",
              "&:hover, &:focus-visible": { backgroundColor: "rgba(255, 255, 255, 0.16)" },
            }}
          >
            <Icon size={15} />
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
});

ImageActionsToolbar.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string.isRequired, Icon: PropTypes.elementType.isRequired, onClick: PropTypes.func.isRequired })
  ).isRequired,
  tooltipProps: PropTypes.object,
  className: PropTypes.string,
  sx: PropTypes.object,
};
